import ViewActionIcon from 'icons/ViewActionIcon'
import EditActionIcon from 'icons/EditActionIcon'
import DeleteActionIcon from 'icons/DeleteActionIcon'

const rowActions = ({ canEdit, canDelete, navigate, selectRow, detailsUrl }) =>
  [
    {
      label: 'Details',
      labelColor: 'white',
      typographyVariant: 'medium',
      desktopIcon: <ViewActionIcon />,
      onClick: (_e, rowId) => navigate(`${detailsUrl}/${rowId}`)
    },
    canEdit && {
      label: 'Edit',
      labelColor: 'white',
      typographyVariant: 'medium',
      desktopIcon: <EditActionIcon />,
      onClick: (_e, rowId) => selectRow(rowId, 'edit')
    },
    canDelete && {
      label: 'Delete',
      labelColor: 'white',
      typographyVariant: 'medium',
      desktopIcon: <DeleteActionIcon />,
      onClick: (_e, rowId) => selectRow(rowId, 'delete')
    }
  ].filter(Boolean) // Filter out false values if canEdit or canDelete is false

export default rowActions

export const statusOptions = [
  { label: 'Enabled', value: 'true' },
  { label: 'Disabled', value: 'false' }
]

export const phoneRegExp =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
